export const env = {
  NODE_ENV: process.env['NODE_ENV'] || 'production',
  ANALYTICS_ID: process.env['NEXT_PUBLIC_ANALYTICS_ID'] || '',
  FEATURES_ID: process.env['NEXT_PUBLIC_FEATURES_ID'] || '',
  MUI_X_KEY: process.env['NEXT_PUBLIC_MUI_X_LICENSE_KEY'] || '',
  GOOGLE_MAPS_KEY: process.env['NEXT_PUBLIC_GOOGLE_MAPS_KEY'] || '',
};

export const AUTH = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
};

// Traffic-tagging header (MKT-455 / TG-2). Every request the web app sends to
// medscout-api is stamped with this so the API can attribute traffic to the web
// client. Governance/attribution signal only — it is spoofable and must never
// gate anything security-relevant. Applied at every transport that reaches the
// API (RTK Query base query, the legacy axios instance, and the raw-fetch Scout
// chat / websocket-ticket paths).
export const CLIENT_HEADER = {
  NAME: 'X-MedScout-Client',
  WEB: 'web',
};
